import { render } from "./RequestReset.vue?vue&type=template&id=015e5392&scoped=true"
import script from "./RequestReset.vue?vue&type=script&lang=js"
export * from "./RequestReset.vue?vue&type=script&lang=js"

import "./RequestReset.vue?vue&type=style&index=0&id=015e5392&lang=scss&scoped=true"

import exportComponent from "/Users/thuyninh/Sites/yamaha_lms_fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015e5392"]])

export default __exports__